export default function ConvertToNumber(value) {
  return !value || Number.isNaN(Number(value)) ? 0 : Number(value);
}
